var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginPopupSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 16,
    fill: "#10B981"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 29.6C22.5461 29.6 24.9879 28.5886 26.7882 26.7883C28.5886 24.9879 29.6 22.5461 29.6 20C29.6 17.4539 28.5886 15.0121 26.7882 13.2118C24.9879 11.4115 22.5461 10.4 20 10.4C17.4539 10.4 15.0121 11.4115 13.2118 13.2118C11.4114 15.0121 10.4 17.4539 10.4 20C10.4 22.5461 11.4114 24.9879 13.2118 26.7883C15.0121 28.5886 17.4539 29.6 20 29.6V29.6ZM24.4484 18.4484C24.667 18.2221 24.7879 17.919 24.7852 17.6043C24.7825 17.2897 24.6563 16.9887 24.4338 16.7662C24.2113 16.5438 23.9103 16.4175 23.5957 16.4148C23.281 16.4121 22.9779 16.533 22.7516 16.7516L18.8 20.7032L17.2484 19.1516C17.0221 18.933 16.719 18.8121 16.4043 18.8148C16.0897 18.8176 15.7887 18.9438 15.5662 19.1662C15.3437 19.3887 15.2175 19.6897 15.2148 20.0043C15.2121 20.319 15.333 20.6221 15.5516 20.8484L17.9516 23.2484C18.1766 23.4734 18.4818 23.5998 18.8 23.5998C19.1182 23.5998 19.4234 23.4734 19.6484 23.2484L24.4484 18.4484V18.4484Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPopupSuccess);
export default __webpack_public_path__ + "static/media/login-popup-success.804179a90996d7371919472bb09cc962.svg";
export { ForwardRef as ReactComponent };